<template lang="pug">

div

    .four.fields

        //- Name
        text-field(label='Name' v-model='name' v-bind:isRequired='true')
            field-error(v-bind:validation='validation' attribute='name')

        //- Kürzel
        text-field(label='Kürzel' v-model='shortcode' v-bind:isRequired='true')
            field-error(v-bind:validation='validation' attribute='shortcode')

        //- Verantwortlicher Medienproduktioner
        dropdown-field(
            label='Medienproduktioner'
            optionLabel='fullName' optionValue='id'
            v-bind:options='mediaProductionUsersWithFullName'
            v-bind:isRequired='true'
            v-model='mediaProductionUser'
        )
            field-error(v-bind:validation='validation' attribute='mediaProductionUser')

        //- Status
        dropdown-field(
            label='Status'
            optionValue='id' optionLabel='name'
            v-bind:options='statusOptions'
            v-bind:isRequired='true'
            v-bind:withEmptyOption='false'
            v-model='status'
        )
            field-error(v-bind:validation='validation' attribute='status')

    //- Bemerkung
    textarea-field(label='Bemerkung' v-model='notice')

    //- Freitext-Felder
    .three.fields
        text-field(label='Freitext 1' v-model='freeText1' placeholder='keine Angabe')
        text-field(label='Freitext 2' v-model='freeText2' placeholder='keine Angabe')
        text-field(label='Freitext 3' v-model='freeText3' placeholder='keine Angabe')

</template>

<script>
    import * as R from 'ramda'
    import { Validator } from 'simple-vue-validator'
    import { full_name } from '@/utils/person'
    import DropdownField from '@/components/form/DropdownField.vue'
    import FieldError from '@/components/form/SmartFieldError'
    import Error from '@/components/form/FieldError.vue'
    import TextareaField from '@/components/form/TextareaField.vue'
    import TextField from '@/components/form/TextField.vue'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { DropdownField, Error, FieldError, TextareaField, TextField },

        computed: {

            freeText1: {
                get() { return this.value.freeText1 },
                set(value) { this.updateValue('freeText1', value) }
            },

            freeText2: {
                get() { return this.value.freeText2 },
                set(value) { this.updateValue('freeText2', value) }
            },

            freeText3: {
                get() { return this.value.freeText3 },
                set(value) { this.updateValue('freeText3', value) }
            },

            mediaProductionUser: {
                get() { return this.value.mediaProductionUser },
                set(value) { this.updateValue('mediaProductionUser', value) }
            },

            name: {
                get() { return this.value.name },
                set(value) { this.updateValue('name', value) }
            },

            notice: {
                get() { return this.value.notice },
                set(value) { this.updateValue('notice', value) }
            },

            shortcode: {
                get() { return this.value.shortcode },
                set(value) { this.updateValue('shortcode', value) }
            },

            status: {
                get() { return this.value.status },
                set(value) { this.updateValue('status', value) }
            },

            mediaProductionUsersWithFullName() {
                return this.mediaProductionUserModels.map(user => {
                    const person = this.$store.getters['persons/byId'](user.person)
                    return {
                        id: user.id,
                        fullName: person ? full_name(person) : String(user.id)
                    }
                })
            }

        },

        data() {
            return {
                statusOptions: [
                    { id: 'HAS_ACCESS', name: 'Aktiv' },
                    { id: 'HAS_NO_ACCESS', name: 'Inaktiv' }
                ]
            }
        },

        created() {
            if (!['HAS_ACCESS', 'HAS_NO_ACCESS'].includes(this.status)) {
                this.status = 'HAS_ACCESS'
            }
        },

        props: {

            mediaProductionUserModels: {
                type: Array,
                required: true
            },

            personModels: {
                type: Array,
                required: true
            },

            value: {
                type: Object,
                required: true
            }

        },

        methods: {

            updateValue(prop, value) {
                this.$emit('input', R.assoc(prop, value, this.value))
            },

            validate() {
                return this.$validate()
            }

        },

        validators: {

            mediaProductionUser(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte einen verantwortlichen Medienproduktioner auswählen')
            },

            name(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte einen Namen eingeben')
            },

            shortcode(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte ein Kürzel eingeben')
            },

            status(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte einen Status auswählen')
            }

        },

    }

</script>

<style scoped>
    /* Responsive layout for the four-column row:
       - desktop: 4 columns (Fomantic default)
       - tablet: 2 columns for comfortable reading
       - mobile: 1 column (Fomantic stacks fields below 768px by default) */
    @media only screen and (min-width: 768px) and (max-width: 991.98px) {
        .four.fields {
            flex-wrap: wrap;
            margin-bottom: 0;
        }

        .four.fields > .field {
            width: 50% !important;
            margin-bottom: 1em;
        }
    }
</style>
